<template>
	<div class="page">
		<el-card>
			<div slot="header" class="card-header">
				<span>实名审核</span>
				<div style="float:right">
					<el-select v-model="status" size="small" style="width:140px" @change="search">
						<el-option label="全部" :value="null"></el-option>
						<el-option label="待审核" :value="0"></el-option>
						<el-option label="已通过" :value="1"></el-option>
						<el-option label="已拒绝" :value="2"></el-option>
					</el-select>
				</div>
			</div>
			<el-table :data="list" v-loading="loading" border stripe>
				<el-table-column prop="id" label="ID" width="70"></el-table-column>
				<el-table-column prop="userName" label="用户名" min-width="110"></el-table-column>
				<el-table-column prop="nickName" label="昵称" min-width="110"></el-table-column>
				<el-table-column prop="realName" label="姓名" min-width="100"></el-table-column>
				<el-table-column prop="idCardNoMasked" label="身份证号" min-width="170"></el-table-column>
				<el-table-column label="证件照" width="170">
					<template slot-scope="scope">
						<el-button size="mini" :disabled="!scope.row.hasFront" @click="showImage(scope.row, 'front')">人像面</el-button>
						<el-button size="mini" :disabled="!scope.row.hasBack" @click="showImage(scope.row, 'back')">国徽面</el-button>
					</template>
				</el-table-column>
				<el-table-column label="状态" width="90">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.status === 0" type="warning">待审核</el-tag>
						<el-tag v-else-if="scope.row.status === 1" type="success">已通过</el-tag>
						<el-tag v-else type="danger">已拒绝</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="rejectReason" label="拒绝原因" min-width="120"></el-table-column>
				<el-table-column prop="createdTime" label="申请时间" min-width="150"></el-table-column>
				<el-table-column label="操作" width="150" fixed="right">
					<template slot-scope="scope">
						<template v-if="scope.row.status === 0">
							<el-button size="mini" type="success" @click="audit(scope.row, true)">通过</el-button>
							<el-button size="mini" type="danger" @click="audit(scope.row, false)">拒绝</el-button>
						</template>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination style="margin-top:16px" background layout="total, prev, pager, next"
				:total="total" :current-page="pageNo" :page-size="pageSize"
				@current-change="onPage"></el-pagination>
		</el-card>

		<el-dialog title="证件照查看" :visible.sync="imageVisible" width="420px">
			<el-image v-if="imageUrl" :src="imageUrl" style="width:100%" fit="contain"></el-image>
			<div style="color:#909399;font-size:12px;margin-top:8px">链接5分钟内有效,关闭后重新打开会生成新链接</div>
		</el-dialog>
	</div>
</template>

<script>
import AdminApi from '../../api/adminApi.js'

export default {
	data() {
		return {
			loading: false,
			list: [],
			total: 0,
			pageNo: 1,
			pageSize: 10,
			status: null,
			imageVisible: false,
			imageUrl: ''
		}
	},
	created() {
		this.load()
	},
	methods: {
		load() {
			this.loading = true
			new AdminApi().listRealname(this.pageNo, this.pageSize, this.status).then((page) => {
				this.list = page.records || []
				this.total = page.total || 0
			}).catch(() => {}).finally(() => {
				this.loading = false
			})
		},
		search() {
			this.pageNo = 1
			this.load()
		},
		onPage(p) {
			this.pageNo = p
			this.load()
		},
		showImage(row, side) {
			new AdminApi().realnameImage(row.id, side).then((data) => {
				this.imageUrl = data.url
				this.imageVisible = true
			}).catch(() => {})
		},
		audit(row, pass) {
			if (pass) {
				this.$confirm(`确认通过 '${row.nickName}' 的实名认证吗?`, '确认通过?', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					new AdminApi().auditRealname(row.id, true, '').then(() => {
						this.$message.success('已通过')
						this.load()
					}).catch(() => {})
				}).catch(() => {})
			} else {
				this.$prompt('拒绝原因', '拒绝 ' + row.nickName + ' 的实名认证', {
					inputType: 'textarea',
					inputPlaceholder: '请输入拒绝原因(必填)'
				}).then(({ value }) => {
					if (!value || !value.trim()) {
						this.$message.error('拒绝时必须填写原因')
						return
					}
					new AdminApi().auditRealname(row.id, false, value).then(() => {
						this.$message.success('已拒绝')
						this.load()
					}).catch(() => {})
				}).catch(() => {})
			}
		}
	}
}
</script>

<style scoped>
.card-header {
	font-weight: 600;
}
</style>
